import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { AssignmentHistoryModel } from 'shared/components/assignment-history/models/assignment-history.model';
import { TextChatsService } from 'common/text-chats/text-chats.service';
import { ChatsService } from 'common/chats/chats.service';
@Component({
  selector: 'app-assignment-history',
  templateUrl: './assignment-history.component.html',
  styleUrls: ['./assignment-history.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AssignmentHistoryComponent implements OnChanges {
  @Input()
  public chatId: string;
  @Input()
  public textChatId: string;
  @Input()
  public isItemClosed: boolean = false;
  public assignmentHistory: AssignmentHistoryModel[] = [];
  public dataLoaded: boolean = false;
  constructor(private _chatsService: ChatsService,
              private _textChatsService: TextChatsService,
              private _changeDetector: ChangeDetectorRef) {}
  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.chatId || changes.textChatId) {
      this.dataLoaded = false;
      this._fetchAssignmentHistory();
    }
  }
  public hasMoreThanOneAssignmentHistoryItem(): boolean {
    return this.assignmentHistory.length > 1;
  }
  public isClosedItem(): boolean {
    return this.isItemClosed;
  }
  private async _fetchAssignmentHistory(): Promise<void> {
    if (this.chatId) {
      await this._initChatAssignmentHistoryItems(this.chatId);
    }
    if (this.textChatId) {
      await this._initTextChatAssignmentHistoryItems(this.textChatId);
    }
    this.dataLoaded = true;
    this._changeDetector.detectChanges();
  }
  private async _initChatAssignmentHistoryItems(chatId: string): Promise<void> {
    this.assignmentHistory = await this._chatsService.getAssignmentHistoryByChatId(chatId);
  }
  private async _initTextChatAssignmentHistoryItems(textChatId: string): Promise<void> {
    this.assignmentHistory = await this._textChatsService.getAssignmentHistoryByTextChatId(textChatId);
  }
}
